import React from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useLocation } from 'react-router-dom';
import ProfileFormWrapper from './components/ProfileFormWrapper';
import ProfileSubnav from './components/ProfileSubnav';
import CurrentProfileProvider from './providers/CurrentProfile/CurrentProfile.provider';
import BossModeBanner from '../Portfolio/subrouters/Seller/subrouters/ListingDetailSeller/subrouters/ListingInformation/components/BossModeBanner';
import { ADMIN_DASHBOARD_ROUTE } from 'data/global';

import './Profile.styles.scss';

const ProfileRouter: React.FC = () => {
  const { pathname } = useLocation();

  const { t } = useTranslation();

  const isBossMode = pathname.includes(ADMIN_DASHBOARD_ROUTE);

  return (
    <CurrentProfileProvider>
      <div className="profile-router">
        {isBossMode && (
          <BossModeBanner description={t('beCarefulEditingCustomerInfo')} />
        )}

        <h1>{t('accountSettings')}</h1>
        <ProfileSubnav isBossMode={isBossMode} />
        <ProfileFormWrapper>
          <Outlet />
        </ProfileFormWrapper>
      </div>
    </CurrentProfileProvider>
  );
};

export default ProfileRouter;
